import React from 'react';
import { Typography } from '@mui/material';
import moment from 'moment';
import { UnitData } from '@Src/_basic/object/WeightUnitManageType';

interface Props {
  row: UnitData;
}
export default function LastUpdateTimeColumnFormatter(props: Props) {
  const { row } = props;
  return <Typography variant="inherit">{moment(row.lastUpdateTime).format('YYYY/MM/DD HH:mm:ss')}</Typography>;
}
